import { UserType } from '../../../enums/user-type'
import { IAccountUser } from '../../../interfaces/account-user'

export class NewUserRequestDto {
    public userType: UserType
    public email: string
    public accounts?: IAccountUser[]
}
